import React from 'react';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import Dropdown from '../../../../../../components/Dropdown';
import DrugSearchInputClean from '../../DrugSearchInputClean.jsx';

export default function RowBottom({ styles, rsStyles, categories, f, errors = {} }) {
  const isOther = f.rawCategory === 'Other';

  const baseCategories = Array.isArray(categories) ? categories : [];
  const unique = Array.from(new Set(baseCategories));

  let categoryOptions =
    f.rawCategory && f.rawCategory !== 'Other' && !unique.includes(f.rawCategory)
      ? [f.rawCategory, ...unique]
      : unique;

  // Always ensure "Other" is present exactly once at the end
  categoryOptions = [
    ...categoryOptions.filter(opt => String(opt) !== 'Other'),
    'Other',
  ];

  // Custom search function for categories
  const searchCategories = (term) => {
    const filtered = categoryOptions.filter(option =>
      String(option).toLowerCase().includes(term.toLowerCase())
    );
    return filtered.map(option => ({
      sku: option,
      name: option,
      categoryName: option
    }));
  };

  return (
    <FormRow className={rsStyles.rowSpinnersBottom}>
      <Field label="Category" error={errors?.category}>
        <DrugSearchInputClean
          id="category-search"
          initialValue={f.rawCategory || ''}
          placeholder="Search category"
          searchBackend={searchCategories}
          getDisplayValue={(item) => item?.name || ''}
          dropdownOnly={true}
          openDropdownOnFocus={true}
          minSearchLength={0}
          onSelect={(item) => {
            const category = item?.name || '';
            f.setCategory(category);
            if (category !== 'Other') {
              f.setCustomCategory('');
            }
          }}
          size="default"
          borderRadius="8px"
          noResultsMessage="No categories found"
        />
      </Field>

      {isOther ? (
        <Field label="Other" error={errors?.category}>
          <input
            className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
            type="text"
            value={f.customCategory}
            onChange={e => f.setCustomCategory(e.target.value)}
            placeholder="Enter category"
          />
        </Field>
      ) : (
        <div />
      )}
    </FormRow>
  );
}